import { compressImageBlob } from './compressBrowserImages';

export const compressBlob = async (
  file: File,
  maxFileAge: number
): Promise<Blob> => {
  const data = await compressImageBlob({ file, maxFileAge });
  const parts = data.split(',');
  let base64Data = data;
  if (parts.length > 1) {
    base64Data = parts[1];
  }
  const blob = b64toBlob(base64Data, file.type);
  return blob;
};

const b64toBlob = (b64Data: string, contentType = '', sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};
